import React, { FunctionComponent, useMemo } from "react";
import { Theme, makeStyles, Typography } from "@material-ui/core";
import { Link } from "@material-ui/core";

const URL_REGEX = /(https?:\/\/[^\s]+)/gim;

const useStyles = makeStyles((theme: Theme) => ({
  cardBottomBody: {
    fontSize: 14,
    fontWeight: 300,
    whiteSpace: "break-spaces",
  },
  cardBottomLink: {
    color: theme.palette.primary.light,
    fontSize: 14,
    fontWeight: 500,
    fontStyle: "italic",
    wordBreak: "break-all",
  },
}));

interface IReferenceTextProps {
  reference: string;
}

export const ReferenceText: FunctionComponent<IReferenceTextProps> = (props) => {
  const { reference } = props;
  const classes = useStyles();

  const urlsInText = useMemo(() => {
    const matches = reference.match(URL_REGEX);
    return matches;
  }, [reference]);

  const textSplitOnUrls = useMemo(() => {
    const regexUrls = urlsInText?.map((url: string) => url.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1"));
    return reference.split(new RegExp(`(${regexUrls?.join("|")})`));
  }, [reference, urlsInText]);

  return (
    <Typography className={classes.cardBottomBody}>
      {textSplitOnUrls.map((text, idx) => {
        let isLink = urlsInText?.includes(text);
        return (
          <span key={idx}>
            {!isLink && text}
            {isLink && (
              <Link href={text} className={classes.cardBottomLink} target="_blank">
                {text}
              </Link>
            )}
          </span>
        );
      })}
    </Typography>
  );
};
